import PlayerScores from './player-scores';
import './player-scores.scss';

export default PlayerScores;